import React, { createContext, useReducer, useEffect } from 'react';
import FullCard from '../../../../../components/Card/FullCard';
import AddForm from './AddForm';
import { initialState, reducer, actions } from './reducer';
import { useLocation } from 'react-router-dom';
import AccessDenied from '../../../../../components/OtherElements/AccessDenied';
import BriefInfo from '../../../../../components/User/BriefInfo';
import Divider from '@material-ui/core/Divider';
import useTitle from 'hooks/useTitle';

export const store = createContext(null);
const { Provider } = store;

const AddOrder = () => {
  useTitle('افزودن سفارش جدید');
  const [state, dispatch] = useReducer(reducer, initialState);
  const location = useLocation();
  const { order } = location?.state;

  const replaceOrderData = async (order) => {
    const {
      fleetOptions,
      fleetCount,
      proposedPrice,
      basePrice,
      customer,
    } = order;
    const cargo = order?.cargos?.[0] || {};
    const {
      type,
      quantity,
      packaging,
      value,
      load,
      workers,
      loadTime,
      origin,
      destination,
      unloadTime,
      description,
      description2,
      unit,
    } = cargo;
    const insurance = await actions.calcInsurance(value);
    const payload = {
      type,
      quantity,
      packaging,
      value,
      load,
      workers,
      loadTime,
      origin,
      destination,
      unloadTime,
      fleetOptions,
      fleetCount,
      description,
      description2,
      weight: quantity,
      weightType: unit,
      proposedPrice,
      basePrice: basePrice ? basePrice : proposedPrice * 1 - insurance * 1,
      customer,
    };
    dispatch({ type: 'REORDER', payload: payload });
  };

  useEffect(() => {
    if ((order && order.cargos) || (order && order.basePrice)) {
      replaceOrderData(order);
    } else if (order && order.customer) {
      dispatch({
        type: 'CHANGE_VALUES',
        payload: { name: 'customer', value: order.customer },
      });
    }
  }, []);

  return (
    <Provider value={{ state, dispatch, actions }}>
      {order ? (
        <FullCard
          title="افزودن سفارش جدید"
          category="جهت افزودن سفارش جهت صاحب‌بار بصورت دستی"
        >
          <BriefInfo user={order.customer} showActions={false} />
          <Divider style={{ margin: `10px 0` }} />
          <AddForm />
        </FullCard>
      ) : (
        <AccessDenied />
      )}
    </Provider>
  );
};

export default React.memo(AddOrder);
